/* eslint-disable */
export default {
  dialPlaceholder: '輸入姓名或號碼',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
